<template>
  <div :class="$style.HomeWorkModal">
    <el-input v-model="theme" placeholder="Тема занятий"/>

    <vue-editor
      :class="$style.editor"
      v-model="note"
      :disabled="componentData.readOnly"
      placeholder="Введите текст домашнего задания"
    />

    <div :class="$style.bottom">
      <el-upload
        v-if="!componentData.readOnly"
        :action="' '"
        :auto-upload="false"
        multiple
        :limit="3"
        :showFileList="false"
        :on-change="handleChangeFiles"
      >
        <el-button slot="trigger" >Выбрать файл</el-button>
      </el-upload>

      <div>
        <el-badge v-if="fileList.length" :value="fileList.length" :class="$style.badge">
          <el-collapse v-model="activeNames">
            <el-collapse-item title="Прикреплённые файлы" name="1">
              <file-list
                :class="$style.fileList"
                :list.sync="fileList"
                :read-only="componentData.readOnly"
              />
            </el-collapse-item>
          </el-collapse>
        </el-badge>
      </div>

      <el-button
        v-if="!componentData.readOnly"
        :class="$style.button"
        :disabled="!stateIsChange"
        type="primary"
        @click="saveHomeWork"
      >
        Сохранить
      </el-button>
    </div>
  </div>
</template>

<script>
const regExpLink = /(http|ftp|https):\/\/([\w_-]+(?:(?:\.[\w_-]+)+))([\w.,@?^=%&:\/~+#-]*[\w@?^=%&\/~+#-])/;
import fileList from "@/components/common/fileList.vue";
import VButton from "@/components/ui/VButton";
import sleep from '@/utils/sleep';
import { VueEditor } from "vue2-editor";

export default {
  name: 'HomeWorkModal',

  props: {
    componentData: {
      type: Object,
      default: () => ({})
    }
  },

  components: {
    VueEditor,
    VButton,
    fileList,
  },

  data() {
    return {
      isInit: false,
      stateIsChange: false,
      fileList: [],
      note: this.componentData.note,
      theme: this.componentData.theme,
      activeNames: ['1']
    };
  },

  watch: {
    'fileList.length'() {
      console.log(this.isInit)
      if (this.isInit) {
        this.stateIsChange = true;
      }
    },

    note() {
      this.stateIsChange = true;
    },

    theme() {
      this.stateIsChange = true;
    }
  },

  async created() {
    this.fileList = this.componentData.files.map(item => ({
      name: 'Файл',
      link: item,
    }));
    await sleep(300)
    this.isInit = true;
  },

  methods: {
    handleChangeFiles(file) {
      if (this.fileList.length < 3) {
        this.fileList.push(file)
      }
    },

    isLink(text) {
      const result = regExpLink.test(text);
      return result;
    },

    async saveHomeWork() {
      const payload = this.createFormData();
      this.componentData.cb && this.componentData.cb(payload);
    },

    createFormData() {
      const formData = new FormData();
      formData.append('note', this.note);
      formData.append('theme', this.theme);

      if (this.fileList.length) {
        this.fileList.forEach((el, idx) => {
          if (el.hasOwnProperty('link')) {
            formData.append(`uploadedFiles[${idx}]`, el.link);
          } else {
            formData.append("files[" + idx + "]", el.raw);
          }
        });
      }

      return formData;
    },

    notify(status, text){
      const h = this.$createElement
      this.$notify({
        title: '',
        message: h('i', { style: `color: ${status ?  '#67C23A' : ' #f56c6c' }` }, text)
      });
    }
  }
}
</script>

<style lang="scss" module>
  .HomeWorkModal {
    display: grid;
    grid-template-rows: auto 1fr auto;
    row-gap: 16px;
    height: calc(100% - 35px);
  }

  .editor {
    display: grid;
    grid-template-rows: auto 1fr;
  }

  .inputFile {
    visibility: hidden;
    width: 0;
    height: 0;
  }

  .bottom {
    display: grid;
    align-items: flex-end;
    grid-template-columns: auto 1fr auto;
    column-gap: 20px;
  }

  .badge {
    :global(.el-collapse-item__header) {
      height: 40px;
      width: 200px;
    }

    :global(.el-collapse-item__content) {
      padding-bottom: 0;
    }
  }

  .bottomCenter {
    // max-height: 40px;
  }

  .fileList {
    width: 200px;
  }
</style>
